export default __webpack_public_path__ + "static/mini-hero-tv-4c6bde689847dbfac485f2cf0c4f50e9.jpg";